// Redutor puro por trás de `useBudgetStats` (flows/proposta.md R11, permuta.md R11).
// Receita = só propostas `accepted`; "no mês" usa created_at >= 1º dia do mês
// de `now`. Permuta entra na receita e aparece à parte como rodapé — nunca
// é subtraída.

export interface StatableBudget {
  status: string;
  net_total: number | null;
  barter_total: number | null;
  created_at: string;
}

export interface BudgetStats {
  totalRevenue: number;
  monthlyRevenue: number;
  /** Parte de `monthlyRevenue` acertada em serviços (rodapé "R$ X em permuta"). */
  monthlyBarter: number;
  pendingCount: number;
  totalCount: number;
  byStatus: Record<string, number>;
}

export function computeBudgetStats(budgets: StatableBudget[], now: Date = new Date()): BudgetStats {
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
  const accepted = budgets.filter((b) => b.status === "accepted");
  const acceptedThisMonth = accepted.filter((b) => b.created_at >= startOfMonth);
  const sum = (rows: StatableBudget[], pick: (b: StatableBudget) => number | null) =>
    rows.reduce((acc, b) => acc + Number(pick(b) ?? 0), 0);

  return {
    totalRevenue: sum(accepted, (b) => b.net_total),
    monthlyRevenue: sum(acceptedThisMonth, (b) => b.net_total),
    monthlyBarter: sum(acceptedThisMonth, (b) => b.barter_total),
    pendingCount: budgets.filter((b) => b.status === "sent").length,
    totalCount: budgets.length,
    byStatus: budgets.reduce<Record<string, number>>((acc, b) => {
      acc[b.status] = (acc[b.status] || 0) + 1;
      return acc;
    }, {}),
  };
}
